<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button class="inline btn-style" @click="navigateToSuggestedReviews">{{ $t("socialReviews.suggestedReviews") }}</el-button>
      <el-button class="inline">
        <download-excel :fetch="exportReviews" type="xls" :fields="jsonFields" :name="nomFichierReviews">
          {{ $t("portals.report.exportResults") }}
        </download-excel>
      </el-button>
    </template>
    <el-form @submit.prevent.native="search()" label-position="top" v-if="userRS.length > 0">
      <ubi-panel>
        <h2>{{ $t("socialReviews.title") }}</h2>
        <div>
          <p class="text-justify">{{ $t("socialReviews.description") }}</p>
        </div>
      </ubi-panel>
      <!--      <social-reviews-search></social-reviews-search>-->
      <social-reviews-stats style="margin-top: -20px;"></social-reviews-stats>
      <social-reviews-table style="margin-top: -20px;"></social-reviews-table>
    </el-form>

  </ubi-page-container>
</template>

<script>
import SocialReviewsTable from '@/pages/SocialReviews/Blocks/SocialReviewsTable'
import SocialReviewsStats from '@/pages/SocialReviews/Blocks/SocialReviewsStats'
import UbiPanel from '@/components/Panel'
import moment from 'moment'

export default {
  components: {
    UbiPanel,
    SocialReviewsTable,
    SocialReviewsStats
  },
  data () {
    return {
      nomFichierReviews: `${this.$t('socialReviews.export.fileNameExportReviews')}_${moment().format('DD/MM/YYYY')}.xls`,
      dataForExport: null,
      jsonFields: {
        [this.$t('socialReviews.export.noticeContent')]: 'contenu_avis',
        [this.$t('socialReviews.export.dateOfPublication')]: 'date_publication',
        [this.$t('socialReviews.export.dealerName')]: 'nom_depositaire',
        [this.$t('socialReviews.export.pointOfSaleName')]: 'point_de_vente',
        [this.$t('socialReviews.export.numberOfStars')]: 'nombre_etoiles'
      }
    }
  },
  computed: {
    userRS () {
      return this.$store.getters.getUser.socialNetworkIds
    },
    universe () {
      return this.sitimmoUser.univers
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    search () {
      const payload = {
        id: this.sitimmoUser.login
      }
      this.$store.dispatch('socialReviewsList/loadSocialReviews', payload)
    },
    navigateToSuggestedReviews () {
      this.$router.push({ name: 'suggested-reviews' })
    },
    exportReviews () {
      this.$store.dispatch('socialReviewsList/exportReviews')
      return this.$store.getters['socialReviewsList/getExportReviews']
    }
  }
}
</script>

<style scoped>
.btn-style {
  background-color: #46A3B9;
  color:#FFF;
}
</style>
